import { Box } from '@chakra-ui/react';

import { Condition } from 'Component/others';
import useGetPresences from 'Domain/host-attendance-record/useGetPresences';
import AttendanceOverview from 'View/host/section/attendance-overview';
import { SkeletonHostAttendance } from 'View/host/component/skeleton';
import AttendanceRecordItem from 'View/host-presence-content/components/attendance-record-item';
import LivestreamRecordItem from 'View/host-presence-content/components/livestream-record-item';
import { hostPresenceOverviewText } from 'Const/host-presence-content/view';

import styles from './styles.module.css';

const OverviewPresence = () => {
  const { data: presenceData, isLoading: isLoadingPresence } = useGetPresences();

  const { streamingSessions } = presenceData ?? {};

  return (
    <Box className={styles['overview-presence__container']}>
      <Condition statement={!isLoadingPresence} fallback={<SkeletonHostAttendance />}>
        <AttendanceOverview presenceData={presenceData}>
          <AttendanceRecordItem presenceData={presenceData} />
          <LivestreamRecordItem label={hostPresenceOverviewText.livestream1Text} livestreamData={streamingSessions?.[0]} />
          <LivestreamRecordItem label={hostPresenceOverviewText.livestream2Text} livestreamData={streamingSessions?.[1]} />
          <LivestreamRecordItem label={hostPresenceOverviewText.livestream3Text} livestreamData={streamingSessions?.[2]} />
        </AttendanceOverview>
      </Condition>
    </Box>
  );
};

export default OverviewPresence;
